var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Homeicon"),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c(
          "ul",
          { staticClass: "items" },
          _vm._l(_vm.shuffle_itemList, function(item, index) {
            return _c("li", {
              key: item.id,
              class: ["item-" + index],
              attrs: { id: index },
              on: {
                touchmove: function($event) {
                  $event.preventDefault()
                  return _vm.dragging(index)
                },
                touchstart: function($event) {
                  $event.preventDefault()
                  return _vm.drag(index)
                },
                touchend: function($event) {
                  $event.preventDefault()
                  return _vm.drop(index)
                }
              }
            })
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "dropzone1" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "dropzone2" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "dropzone3" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "dropzone4" } }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPlay1,
            expression: "isPlay1"
          }
        ],
        staticClass: "growing-button1",
        attrs: { src: require("@/assets/img/アセット 9@3x.png") }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPlay2,
            expression: "isPlay2"
          }
        ],
        staticClass: "growing-button2",
        attrs: { src: require("@/assets/img/アセット 9@3x.png") }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPlay3,
            expression: "isPlay3"
          }
        ],
        staticClass: "growing-button3",
        attrs: { src: require("@/assets/img/アセット 9@3x.png") }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPlay4,
            expression: "isPlay4"
          }
        ],
        staticClass: "growing-button4",
        attrs: { src: require("@/assets/img/アセット 9@3x.png") }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "play-back", on: { click: _vm.musicPlayList } },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPlayList,
                expression: "!isPlayList"
              }
            ],
            attrs: { src: require("@/assets/img/アセット 63@3x.png") }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPlayList,
                expression: "isPlayList"
              }
            ],
            attrs: { src: require("@/assets/img/continuous_playback_stop.png") }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "play-btns" }, [
        _c("ul", { staticClass: "play-btn" }, [
          !_vm.isPlay1
            ? _c("li", { staticClass: "play-btn1" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65@3x.png") },
                  on: { click: _vm.playMusic1 }
                })
              ])
            : _c("li", { staticClass: "play-btn1" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65-2@3x.png") },
                  on: { click: _vm.stopMusic1 }
                })
              ]),
          _vm._v(" "),
          !_vm.isPlay2
            ? _c("li", { staticClass: "play-btn2" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65@3x.png") },
                  on: { click: _vm.playMusic2 }
                })
              ])
            : _c("li", { staticClass: "play-btn2" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65-2@3x.png") },
                  on: { click: _vm.stopMusic2 }
                })
              ]),
          _vm._v(" "),
          !_vm.isPlay3
            ? _c("li", { staticClass: "play-btn3" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65@3x.png") },
                  on: { click: _vm.playMusic3 }
                })
              ])
            : _c("li", { staticClass: "play-btn3" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65-2@3x.png") },
                  on: { click: _vm.stopMusic3 }
                })
              ]),
          _vm._v(" "),
          !_vm.isPlay4
            ? _c("li", { staticClass: "play-btn4" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65@3x.png") },
                  on: { click: _vm.playMusic4 }
                })
              ])
            : _c("li", { staticClass: "play-btn4" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/アセット 65-2@3x.png") },
                  on: { click: _vm.stopMusic4 }
                })
              ])
        ])
      ]),
      _vm._v(" "),
      _c("PittanBtn", {
        ref: "child",
        attrs: {
          isActive1: _vm.isActive1,
          isActive2: _vm.isActive2,
          isActive3: _vm.isActive3,
          isActive4: _vm.isActive4,
          judgment1: _vm.judgment1,
          judgment2: _vm.judgment2,
          judgment3: _vm.judgment3,
          judgment4: _vm.judgment4,
          mistakeactive: _vm.mistakeactive
        },
        on: {
          eventname1: _vm.updateCorrectAnswerFlag1,
          eventname2: _vm.updateCorrectAnswerFlag2,
          eventname3: _vm.updateCorrectAnswerFlag3,
          eventname4: _vm.updateCorrectAnswerFlag4,
          submission: _vm.setActTime,
          stopmusic: _vm.allStopMusic
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b5eb86c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b5eb86c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Gameplay.vue
// module id = null
// module chunks = 